<template>
    <v-container fluid class="pt-0">
        <v-row justify="center" align="center">
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="8" class="text-center" style="position:relative; margin-top: -40px">
                <v-card :disabled="loading">
                    <v-card-title class="py-1" style="background-color: #00aaff"></v-card-title>
                    <v-card-text>
                        <v-text-field v-model="exam.title" style="font-size: 2rem" full-width :readonly="title_edit" :append-outer-icon=" title_edit ? 'mdi-pencil' : 'mdi-close'"  @click:append-outer="title_edit = !title_edit"></v-text-field>
                        <v-textarea v-model="exam.description" dense rows="1" filled label="Descripción" :readonly="description_edit" :append-outer-icon=" description_edit ? 'mdi-pencil' : 'mdi-close'"  @click:append-outer="description_edit = !description_edit"></v-textarea>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" lg="8" v-if="questions.length > 0">
                <template v-for="(question, index) in questions">
                    <v-card :key="index" class="mt-3" :disabled="loading">
                        <v-card-text>
                            <v-row class="py-0">
                                <v-col cols="12" lg="12" md="12" sm="12" class="py-0">
                                    <v-text-field v-model="question.value" filled :label="question.type === 'question' ? 'Pregunta' : 'IFRAME'" clearable hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" lg="12" md="12" sm="12" class="py-0">
                                    <v-row>
                                        <v-col>
                                            <v-select v-model="question.type" :items="types" item-text="text" item-value="value"  label="Tipo" hide-details></v-select>
                                        </v-col>
                                        <v-col>
                                            <v-select v-model="question.level_id" :items="levels" item-text="name" item-value="id" label="Nivel" type="number" min="1" hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-card-subtitle class="px-0 pt-5 pb-0">Opciones</v-card-subtitle>
                            <v-row class="py-0">
                                <template v-for="(option, index) in question.options">
                                    <v-col cols="12" class="py-0" :key="index">
                                        <v-text-field v-model="option.value" onClick="this.select()" prepend-icon="mdi-close-circle-outline" @click:prepend="delete_option(question, option)">
                                            <template v-slot:append-outer>
                                                <v-tooltip right>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-checkbox class="py-0 my-0" v-model="option.correct" v-on="on" v-bind="attrs"></v-checkbox>
                                                    </template>
                                                    <span>Opción correcta</span>
                                                </v-tooltip>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </template>
                                <v-col cols="12" class="py-0">
                                    <p class="blue--text" style="cursor: pointer;" @click="add_option(question)"><v-icon color="blue">mdi-plus</v-icon> Añadir opción...</p>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-divider vertical class="mx-2"></v-divider>
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-on="on" v-bind="attrs" @click="delete_item(question)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eliminar</span>
                            </v-tooltip>
                        </v-card-actions>
                    </v-card>
                </template>
                <v-btn class="mt-2" color="#008dd4" dark @click="save" :loading="loading">GUARDAR</v-btn>
                <v-btn class="mt-2" text href="/placement-exams">ATRÁS</v-btn>
            </v-col>

            <v-col cols="12" lg="8" class="text-center" v-else>
                <v-card>
                    <v-card-text>
                        No hay ninguna pregunta
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon class="mx-auto" v-on="on" v-bind="attrs" @click="add_question">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <span>Agregar pregunta</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn fixed bottom right fab color="primary" dark x-large v-on="on" v-bind="attrs" @click="add_question">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Agregar pregunta</span>
        </v-tooltip>
    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['exam', 'levels'],
    data: () => ({
        update_url:"/placement-exams/update",

        title_edit:true,
        description_edit:true,
        questions:[],

        loading:false,

        types:[
            { text:"Pregunta", value:"question" },
            { text:"Video", value:"video" }
        ],

        temporal_questions_backup:"",
    }),

    mounted(){
        this.questions = JSON.parse(this.exam.questions)
    },

    methods:{
        add_question:function(){
            this.questions.push({
                questionId:this.questions.length + 1,
                value:"",
                type:"question",
                level_id:"",
                options:[
                    { optionId:1, value:"Opción 1", correct:false }
                ],
            })
        },

        delete_item: function(question){
            this.temporal_questions_backup = Array.from(this.questions)
            this.questions.splice(this.questions.indexOf(question), 1)

            var self = this

            iziToast.info({
                title:"Elemento eliminado",
                position:"bottomLeft",
                buttons: [
                    ['<button><b>RESTABLECER</b></button>', function (instance, toast) {
            
                        self.questions = self.temporal_questions_backup
                        instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
            
                    }, true],
                ],
            })
        },

        add_option: function(question){
           question.options.push( {optionId:question.options.length + 1, value:"Opción "+(question.options.length+1), correct:false} )
        },

        delete_option:function(question, option){
            if(question.options.length == 1) return
            question.options.splice(question.options.indexOf(option), 1)
        },

        save:function(){
            if(this.exam.title === ""){
                iziToast.error({
                    title:"Error",
                    message:"El titulo no puede estar vacío",
                    position:"topRight"
                })
                return
            }

            for(let question of this.questions){
                if(question.value === "" || question.level_id === ""){
                    iziToast.error({
                        title:"Error",
                        message:"Complete todos los campos de la pregunta "+(this.questions.indexOf(question)+1),
                        position:"topRight"
                    })
                    return
                }

                let correct = false

                for(let option of question.options){
                    if(option.correct === true){
                        correct = true
                    }
                }

                if(!correct){
                    iziToast.error({
                        title:"Error",
                        message:"Seleccione una opción correcta en la pregunta "+(this.questions.indexOf(question)+1),
                        position:"topRight"
                    })
                    return
                }
            }

            let data = {}
            data.exam_id     = this.exam.id
            data.title       = this.exam.title
            data.description = this.exam.description
            data.questions   = JSON.stringify(this.questions)

            this.loading = true

            axios.post(this.update_url, data).then(response => {
                this.loading = false
                iziToast.success({
                    title:"Correcto",
                    message:"El examen se actualizó correctamente",
                    position:"topRight"
                })
            }).catch(error => {

            })


        }

    }
}
</script>